import { takeLatest, put, call } from 'redux-saga/effects';
import { actionTypes as applicationActions } from '../core/reducers/asyncServerResponseReducer';
import { spinResponseService } from './../gameservice/spinResponseService';

export function* spinCascadeSaga(): Generator<any, any, any> {
  yield takeLatest(applicationActions.GET_APPLICATION_SPIN_CASCADE_RESPONSE, fireSpinResponse);
}



let spincount: number = 0
function* fireSpinResponse(): Generator<any, any, any> {
  try {

    let result_spin = yield call(spinResponseService.sendSpinResponse);

    yield put({
      type: applicationActions.GET_APPLICATION_CASCADE_SUCCESS,
      result_spin
    });

  } catch (error) {
    yield put({
      type: applicationActions.GET_APPLICATION_SPIN_FAILURE,
      error
    });
  }
}

